export const useRecaptchaV2 = () => {
  const { $recaptchaV2 } = useNuxtApp();

  const renderRecaptcha = async (containerId: string, options = {}) => {
    return await $recaptchaV2.render(containerId, options);
  };

  const resetRecaptcha = (containerId?: string) => {
    return $recaptchaV2.reset(containerId);
  };

  const preloadRecaptcha = async () => {
    return await $recaptchaV2.preload();
  };

  const destroyRecaptcha = (containerId?: string) => {
    return $recaptchaV2.destroy(containerId);
  };

  return {
    renderRecaptcha,
    resetRecaptcha,
    preloadRecaptcha,
    destroyRecaptcha,
  };
};
